export function formatPrice(
    priceMax: string | string[],
    priceMin: string | string[]
) {
    const formattedPriceMax = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    }).format(Number(priceMax));

    const formattedPriceMin = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    }).format(Number(priceMin));

    if (priceMax && priceMin) {
        if (priceMax === priceMin) {
            return `Max ${formattedPriceMax}`;
        }

        return `Between ${formattedPriceMin} and ${formattedPriceMax}`;
    } else if (priceMax) {
        return `Max ${formattedPriceMax}`;
    } else if (priceMin) {
        return `Min ${formattedPriceMin}`;
    } else {
        return '';
    }
}
